app
    .controller('ClientLiveAgreementCtrl', function (loginService, $http) {
        this.user = loginService.currentUser;

        this.save = () => {
            this.close();
        };

        this.cancel = () => {
            this.dismiss();
        };

        this.service = {
            id: '1',
            amount: 10,
        };

        this.doCheckout = (stripe) => {
            const fd = new FormData();
            fd.append('stripeToken', stripe.id);
            fd.append('stripeTokenType', stripe.type);
            fd.append('stripeEmail', stripe.email);
            fd.append('api', 'true');

            $http.post(`/coach/service/${this.resolve.service.id}/buy`, fd, {
                headers: {'Content-Type': undefined },
            })
                .then((response) => {
                    if (response.data.error) {
                        this.dismiss();
                        alert(response.data.message);
                    } else {
                        this.close({
                            $value: {
                                success: true
                            }
                        });
                    }
                });
        };

        this.getMinutes = () => {
            return ((this.user.purchasedMinutes || []).find((pd) => {
                return pd.user === this.resolve.coach._id;
            }) || {}).minutes || 0;
        };

        this.config = {
            stripePublicKey: 'pk_test_blDIyDuGE7YKupo8upBS8v2g'
        };

        this.$onInit = () => {

        };
    })
    .component('clientLiveAgreement', {
        template: `
        <div style="max-width: 100vw; width: 360px;">
            <div class="modal-header">
                <h1 style="font-size: 24px; font-family: 'goboldregular', Impact, sans-serif;margin: 10px auto; text-align: center;">
                    <chat-icon type="video" width="20" height="20"></chat-icon>
                    LIVE WORKOUT AGREEMENT
                </h1>
                <button class="btn btn-close" ng-click="$ctrl.cancel()">
                    <chat-icon type="cross" width="15" />
                </button>
            </div>

            <div style="display: flex; justify-content: center;" class="mb-4">
                <div style="display: flex; align-items: center;">
                    With
                </div>
                <div style="display: flex">
                    <img ng-src="{{ $ctrl.resolve.coach.picture }}" style="width: 55px; height: 55px;margin: 0 20px;" />
                    <div style="display: flex; flex-direction: column;">
                        <h3>{{$ctrl.resolve.coach.displayName}}</h3>
                        <span>LEFT {{ $ctrl.getMinutes() }} min</span>
                    </div>
                </div>
            </div>
            <div style="    border: 1px solid #000;width: 50%;text-align: center;font-weight: bold;padding: 10px 5px;margin: 10px auto;">
                ADD {{ $ctrl.resolve.service.bundledHours * 60 }} Minutes
                <br>
                Total: $ {{$ctrl.resolve.service.bundlePrice}}
            </div>
            <div class="container mt-4 mb-4 hide-stripe">
                <button class="btn btn-green w-100" stripe-checkout="$ctrl.doCheckout"
                    data-key="{{$ctrl.config.stripePublicKey}}"
                    data-name="Live Workout"
                    data-email="{{ $ctrl.user.email }}"
                    data-description="Private Live Workout Package"
                    data-amount="{{$ctrl.resolve.service.bundlePrice * 100}}"
                >ACCEPT</button>
            </div>
            <div class="container mb-4">
                <p class="text-center mb-0">You will be redirected to</p>
                <div class="d-flex" style="justify-content: center; align-items: center;">
                    <chat-icon type="stripe" width="75" height="31" class="mr-1"></chat-icon>
                    <chat-icon type="secure-card" width="28" height="21" class="mr-1"></chat-icon>
                    <span>Payment</span>
                </div>
            </div>

        </div>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: 'ClientLiveAgreementCtrl'
    });
